const PHONEFINDER_PATHS = {
    "find-your-phone": {
        "it": "trova-il-tuo-telefono",
        "de": "filo-finden-sie-ihr-handy",
        "es": "filo-find-your-phone",
        "fr": "filo-find-your-phone",
        "en": "find-your-phone"
    },
    "trova-il-tuo-telefono": {
        "it": "trova-il-tuo-telefono",
        "de": "filo-finden-sie-ihr-handy",
        "es": "filo-find-your-phone",
        "fr": "filo-find-your-phone",
        "en": "find-your-phone"
    },
    "filo-find-your-phone": {
        "en": "find-your-phone",
        "it": "trova-il-tuo-telefono",
        "de": "filo-finden-sie-ihr-handy",
        "fr": "filo-find-your-phone",
        "es": "filo-find-your-phone",
    },
    "filo-finden-sie-ihr-handy": {
        "it": "trova-il-tuo-telefono",
        "de": "filo-finden-sie-ihr-handy",
        "es": "filo-find-your-phone",
        "fr": "filo-find-your-phone",
        "en": "find-your-phone"
    }
}

export default PHONEFINDER_PATHS;